import React, { Component } from 'react'

import { StyledButton, SimpleButton } from './styles'

class Button extends Component {
  render() {
    const { children, background, color, border, radius, hover, hoverColor, onSubmit, type } = this.props
    if (type && type === 'none') {
      return (
        <SimpleButton
          background={background}
          color={color}
          border={border}
          radius={radius}
          onClick={onSubmit}
          hover={hover}
          hoverColor={hoverColor}
          type={type}
        >
          {children}
        </SimpleButton>
      )
    } else {
      return (
        <StyledButton
          background={background}
          color={color}
          border={border}
          radius={radius}
          onClick={onSubmit}
          hover={hover}
          hoverColor={hoverColor}
          type={type}
        >
          {children}
        </StyledButton>
      )
    }
  }
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js